<div tabindex="0" class="card personal-information row" *ngIf="data && !editting">
    <div class="personal-information__header col-sm-12">
        {{data.title}}
    </div>
    <div class="col-sm-12 form-group personal-information__content">
        <div class="personal-information__form row">
            <div class="col-xs-1">
                <i class="far fa-user-circle form-icon" aria-hidden="true"></i>
            </div>
            <div class="col-xs-11">
                <label class="personal-information__form__label">
                    {{'Name' | translate}}
                </label>
                <span class="personal-information__form__content">
                    {{profile.name}} {{profile.surname}}
                </span>
            </div>
        </div>

        <div class="personal-information__form row">
            <div class="col-xs-1">
                <i class="fal fa-map form-icon"></i>
            </div>
            <div class="col-xs-11">
                <label class="personal-information__form__label">
                    {{ 'Zip code' | translate }}
                </label>
                <span class="personal-information__form__content">
                    {{profile.zip_code}}
                </span>
            </div>
        </div>

        <div class="personal-information__form row">
            <div class="col-xs-1">
                <i class="fal fa-shield form-icon"></i>
            </div>
            <div class="col-xs-11">
                <label class="personal-information__form__label">
                    {{ 'Type of health insurance' | translate }}
                </label>
                <span class="personal-information__form__content">
                    {{profile.insurance_type | translate}}
                </span>
            </div>
        </div>

        <div class="personal-information__form__button mt-1">
            <button class="btn btn--secondary full-width"
                    (click)="openFormModal({ action: 'update', title: 'Edit Personal Data', url: '', id: profile?.id })">
                {{ 'Edit' | translate}}
            </button>
        </div>
    </div>
</div>

<ng-container *ngIf="!formLoading && editting">
    <div class="card personal-information row" *ngIf="data">
        <div class="personal-information__header col-sm-12">
            {{data.title}}
        </div>

        <div class="col-sm-12 personal-information__form br--none">
            <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form?.valid, urlAPI)"
                  class="mat-form editting-form" #formDirective="ngForm">
                <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                    <div class="col-md-10">
                        <div class="alert alert-danger">
                            <div *ngFor="let error of errorMessage">
                                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                {{ error | translate }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row personal-information__edit">
                    <div class="form-group col-sm-6 col-xs-12 editting-form">
                        <div class="editting-form editting-form__col">
                            <label class="editting-form editting-form__col__field me-form-input"
                                   [class.error]="!(form.controls?.name?.valid || (form.controls?.name?.pristine && !formSubmitted))">
                                <div class="">{{ 'Name' | translate }}*</div>
                                <input type="text"
                                       required="required"
                                       formControlName="name"/>
                            </label>
                            <small class="form-text text-danger"
                                   [hidden]="form.controls?.name?.valid || (form.controls?.name?.pristine && !formSubmitted)">
                                {{ 'Field is required' | translate }}
                            </small>
                        </div>
                    </div>

                    <div class="form-group col-sm-6 col-xs-12 editting-form">
                        <div class="editting-form editting-form__col">
                            <label class="editting-form editting-form__col__field me-form-input"
                                   [class.error]="!(form.controls.surname.valid
                                                                    || (form.controls.surname.pristine && !submitted))">
                                <div class="">{{ 'Last Name' | translate }}*</div>
                                <input type="text"
                                       required="required"
                                       formControlName="surname"/>
                            </label>
                            <small class="form-text text-danger"
                                   [hidden]="form.controls?.surname?.valid || (form.controls?.surname?.pristine && !formSubmitted)">
                                {{ 'Field is required' | translate }}
                            </small>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-6 col-xs-12 editting-form">
                        <div class="editting-form editting-form__col">
                            <label class="editting-form editting-form__col__field me-form-input">
                                <div class="">{{ 'Zip code' | translate }}</div>
                                <input type="text"
                                       formControlName="zip_code"/>
                            </label>
                            <small class="form-text text-danger"
                                   [hidden]="form.controls?.zip_code?.valid || (form.controls?.zip_code?.pristine && !formSubmitted)">
                                {{ 'Field is required' | translate }}
                            </small>
                        </div>
                    </div>
                    <div class="form-group col-sm-6 col-xs-12 editting-form">
                        <div class="editting-form editting-form__col w-100">
                            <label class="form-group col-xs-6 editting-form__col__field w-100 me-form-input icon--left">
                                <div class="title">{{ 'Type of health insurance' | translate }}</div>
                                <i class="fal fa-shield"></i>
                                <select formControlName="insurance_type" type="select">
                                    <option disabled="" value="">{{ 'Please select' | translate }}</option>
                                    <option value="statutory">{{ 'Statuory' | translate }}</option>
                                    <option value="voluntary">{{ 'Voluntary-statuory' | translate }}</option>
                                    <option value="privat">{{ 'Private' | translate }}</option>
                                    <option value="other">{{ 'Other' | translate }}</option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-6 col-xs-12 editting-form">
                        <div class="editting-form editting-form__col w-100">
                            <label class="form-group col-xs-6 editting-form__col__field w-100 me-form-input icon--left">
                                <div class="title">{{ 'Gender identity' | translate }}</div>
                                <i class="fal fa-user-circle"></i>
                                <select formControlName="gender" type="select">
                                    <option disabled="" value="">{{ 'Please select' | translate }}</option>
                                    <option value="2">{{ 'Female' | translate }}</option>
                                    <option value="1">{{ 'Male' | translate }}</option>
                                    <option value="3">{{ 'Non-binary' | translate }}</option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-xs-12 text-xs-right">
                        <button type="button" class="btn btn--secondary mr-r--sm" (click)="editting = false">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button type="submit"
                                [class.disabled]="!form.valid"
                                class="btn btn--primary save">
                            {{ 'Save' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-container>